
import { Component, Vue, Watch } from "vue-property-decorator";
import { ProgramPaths } from "@/enum/ProgramPaths";
import { RehberVideolari } from "@/enum/RehberVideolari";
import { Product } from "@/enum/Product";
import { KisitliIslem } from "@/utils/lisansKisit";
import { sayfaUrunParcasi } from "@/utils/sayfaErisimi";
import FeedbackDialog from "@/components/dialogs/FeedbackDialog.vue";
import axios from "axios";
import { openChatwoot } from "@/plugins/chatwoot";

@Component({
  components: {
    FeedbackDialog,
  },
})
export default class MenuBar extends Vue {
  /**
   * DEV-2113 — menude LISANS kisitiyla kapanan kalemler: izin anahtari -> islem
   * anahtari. Izin ile lisans ayri kavramlardir (DEV-2684): ayni adi tasisalar
   * bile genel olarak eslenmez, yalniz burada yazilanlar sorulur. Acik/kapali
   * karari sunucudan gelir (/ben -> ozellik_durumu).
   */
  static readonly LISANS_ISLEMI: Record<string, KisitliIslem> = {
    // Takip Ac sayfasi yeni takip acar; kisitli donemde kayit sunucuda kapali.
    "takip-ac": "takip-ac",
  };

  items: any = [];
  showFeedbackDialog: boolean = false;

  ofisProItems: Array<any> = [
    {
      id: 1,
      baslikAdi: "Büro Bilgileri",
      route: ProgramPaths.ofispro + "/buro-bilgileri",
      icon: "mdi-bank",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "buro-modulu",
    },
    {
      id: 2,
      baslikAdi: "Vekaletnameler",
      route: ProgramPaths.ofispro + "/vekaletler",
      icon: "mdi-file",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "vekalet-modulu",
    },
    {
      id: 3,
      baslikAdi: "Raporlar",
      route: ProgramPaths.ofispro + "/raporlar",
      icon: "mdi-file-chart",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "rapor-modulu",
    },
    {
      id: 4,
      baslikAdi: "Dilekçeler",
      route: ProgramPaths.ofispro + "/dilekceler",
      icon: "mdi-file-document-edit",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "dilekce-modulu",
    },
    //TODO :: ÇALIŞMADIĞI İÇİN KAPATTTIM @sebo
    {
      id: 5,
      baslikAdi: "Kasa",
      route: ProgramPaths.ofispro + "/kasa",
      icon: "mdi-safe-square",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "kasa-modulu",
    } /*
    {
      id: 6,
      baslikAdi: "Klasörler",
      route: ProgramPaths.ofispro + "/klasorler",
      icon: "mdi-folder",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "klasor-modulu",

    },*/,
    {
      id: 7,
      baslikAdi: "Ajanda",
      route: ProgramPaths.ofispro + "/ajanda",
      icon: "mdi-calendar",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "ajanda-modulu",
    },

    {
      id: 8,
      baslikAdi: "Kullanıcı İzinleri",
      route: ProgramPaths.ofispro + "/kullanici-izinleri",
      icon: "mdi-atom",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "tercih-modulu",
    },
    {
      id: 9,
      baslikAdi: "İşlem Kaydı",
      route: ProgramPaths.ofispro + "/islem-kaydi",
      icon: "mdi-math-log",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "tercih-modulu",
    },
    {
      id: 10,
      baslikAdi: "İcraPro Aktar",
      route: ProgramPaths.ofispro + "/icw-aktar",
      externalUrl: process.env.VUE_APP_AKTAR_TARGET || "http://localhost:8000",
      icon: "mdi-file-download-outline",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "aktar-modulu",
    },
    {
      id: 11,
      baslikAdi: "Genel İstatistikler",
      route: ProgramPaths.ofispro + "/genel-istatistikler",
      icon: "mdi-chart-bar",
      altbaslik: false,
      authorizationKey: "genel-istatistikler",
      altbasliklar: null,
    },
    {
      id: 12,
      baslikAdi: "Uyarılar",
      route: ProgramPaths.ofispro + "/uyarilar",
      icon: "mdi-bell",
      altbaslik: false,
      authorizationKey: "uyarilar-modulu",
      altbasliklar: null
    },
    {
      id: 13,
      baslikAdi: "Hesaplamalar",
      route: ProgramPaths.ofispro + "/hesaplamalar",
      icon: "mdi-calculator",
      altbaslik: false,
      authorizationKey: "hesaplamalar",
      altbasliklar: null
    },
  ];

  icraProItems: Array<any> = [
    {
      id: 1,
      baslikAdi: "Takipler",
      route: null,
      icon: "mdi-account-voice",
      authorizationKey: "takip-listesi",
      altbaslik: true,
      altbasliklar: [
        {
          id: 1,
          baslikAdi: "Takip Aç",
          route: ProgramPaths.icrapro + "/takip-ekle",
          icon: "mdi-plus-thick",
          authorizationKey: "takip-ac",
        },
        {
          id: 2,
          baslikAdi: "Takip Listesi",
          route: ProgramPaths.icrapro + "/takipler",
          icon: "mdi-format-list-numbered",
          authorizationKey: "takip-listesi",
        },
      ],
    },
    {
      id: 2,
      baslikAdi: "Tercihler",
      route: ProgramPaths.icrapro + "/tercihler",
      authorizationKey: "tercihler-modulu",
      icon: "mdi-atom",
      altbaslik: false,
      altbasliklar: null,
    },
    {
      id: 3,
      baslikAdi: "Faiz Hesaplayıcı",
      route: ProgramPaths.icrapro + "/hesaplayici",
      authorizationKey: "faiz-hesaplama-modulu",
      icon: "mdi-calculator",
      altbaslik: false,
      altbasliklar: null,
    },
    {
      id: 5,
      baslikAdi: "Vekâlet Ücreti Hesaplayıcı",
      route: ProgramPaths.icrapro + "/vekalet-ucreti-hesaplayici",
      authorizationKey: "faiz-hesaplama-modulu",
      icon: "mdi-scale-balance",
      altbaslik: false,
      altbasliklar: null,
    },
    {
      id: 4,
      baslikAdi: "Toplu İşlemler",
      route: null,
      icon: "mdi-account-voice",
      authorizationKey: "toplu-xml-indir",
      altbaslik: true,
      altbasliklar: [
        {
          id: 1,
          baslikAdi: "Toplu Xml İndirme",
          route: ProgramPaths.icrapro + "/toplu-isler",
          icon: "mdi-download",
          authorizationKey: "toplu-xml-indir",        },
        {
          id: 2,
          baslikAdi: "Toplu Excel Takip Aç",
          route: ProgramPaths.icrapro + "/toplu-excel",
          icon: "mdi-download",
          authorizationKey: "toplu-excel-takip",        },
        {
          id: 3,
          baslikAdi: "Toplu Takip Tarihi Değiştir",
          route: ProgramPaths.icrapro + "/toplu-takip-tarihi",
          icon: "mdi-download",
          authorizationKey: "toplu-takip-tarihi",        },
        {
          id: 4,
          baslikAdi: "Toplu Takip Durumu Değiştir",
          route: ProgramPaths.icrapro + "/toplu-takip-durumu",
          icon: "mdi-download",
          authorizationKey: "toplu-takip-durumu",        },
        {
          id: 5,
          baslikAdi: "Toplu Not Girme",
          route: ProgramPaths.icrapro + "/toplu-not",
          icon: "mdi-download",
          authorizationKey: "toplu-not",        },
        {
          id: 6,
          baslikAdi: "Toplu İş Ataması",
          route: ProgramPaths.icrapro + "/toplu-is",
          icon: "mdi-download",
          authorizationKey: "toplu-is",        },

      ],
    },
  ];

  eicraProItems: Array<any> = [
    {
      id: 1,
      baslikAdi: "Takip İşlemleri",
      route: null,
      icon: "mdi-account-voice",
      authorizationKey: "takip-surec-yonetimi",
      altbaslik: true,
      altbasliklar: [
        {
          id: 1,
          baslikAdi: "Takip Hazırla (Xml Yükle)",
          route: ProgramPaths.eicrapro + "/takip-hazirla",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu"
        },
        {
          id: 3,
          baslikAdi: "MTS Takip Hazırla",
          route: ProgramPaths.eicrapro + "/mts-takip-hazirla",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 4,
          baslikAdi: "MTS Takip Aç",
          route: ProgramPaths.eicrapro + "/mts-takip-ac",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        // {
        //   id: 5,
        //   baslikAdi: "Takip Hash Listesi",
        //   route: ProgramPaths.eicrapro + "/takip-hash-list",
        //   icon: "mdi-circle-medium",
        //   authorizationKey: "klasor-modulu",
        // },
        {
          id: 2,
          baslikAdi: "Ödeme Bekleyenler",
          route: ProgramPaths.eicrapro + "/takip-ac",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
      ],
    },
    {
      id: 2,
      baslikAdi: "MTS Takip İşlemleri",
      route: null,
      icon: "mdi-office-building",
      authorizationKey: "takip-surec-yonetimi",
      altbaslik: true,
      altbasliklar: [
        {
          id: 1,
          baslikAdi: "MTS Tebligat Gönder",
          route: ProgramPaths.eicrapro + "/mts-tebligat-gonder",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 2,
          baslikAdi: "MTS Ödeme Yap",
          route: ProgramPaths.eicrapro + "/mts-odeme",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
      ],
    },
    {
      id: 3,
      baslikAdi: "İcra İşlemleri",
      route: null,
      icon: "mdi-file-document-multiple-outline",
      authorizationKey: "takip-surec-yonetimi",
      altbaslik: true,
      altbasliklar: [
        {
          id: 1,
          baslikAdi: "Harç / Masraf Ödeme",
          route: ProgramPaths.eicrapro + "/harc-masraf-odeme",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 2,
          baslikAdi: "Toplu Haciz Talebi Gönder",
          route: ProgramPaths.eicrapro + "/toplu-haciz-talebi-gonder",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 3,
          baslikAdi: "Toplu Tebligat Talebi Gönder",
          route: ProgramPaths.eicrapro + "/toplu-tebligat-talebi-gonder",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 4,
          baslikAdi: "Toplu Genel Talep Gönder",
          route: ProgramPaths.eicrapro + "/toplu-genel-talep-gonder",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 5,
          baslikAdi: "Evrak Gönderme",
          route: ProgramPaths.eicrapro + "/evrak-gonder",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 6,
          baslikAdi: "Hazır Evrak Gönder",
          route: ProgramPaths.eicrapro + "/hazir-evrak-gonder",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 7,
          baslikAdi: "Evrak İndir",
          route: ProgramPaths.eicrapro + "/evrak-indir",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 8,
          baslikAdi: "Makbuz İndir",
          route: ProgramPaths.eicrapro + "/makbuz-indir",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
      ],
    },
    {
      id: 4,
      baslikAdi: "Sorgulama",
      route: null,
      icon: "mdi-magnify",
      authorizationKey: "takip-surec-yonetimi",
      altbaslik: true,
      altbasliklar: [
        {
          id: 1,
          baslikAdi: "Takip Sorgulama",
          route: ProgramPaths.eicrapro + "/takip-sorgula",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 2,
          baslikAdi: "Kişi Kurum Sorgulama",
          route: ProgramPaths.eicrapro + "/kisi-kurum-sorgula",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
        {
          id: 3,
          baslikAdi: "Avukat / Vekil Sorgulama",
          route: ProgramPaths.eicrapro + "/vekil-sorgula",
          icon: "mdi-circle-medium",
          authorizationKey: "klasor-modulu",
        },
      ],
    },
    {
      id: 5,
      baslikAdi: "İşlemler",
      route: ProgramPaths.eicrapro + "/islemler",
      icon: "mdi-timer-outline",
      altbaslik: false,
      altbasliklar: null,
      authorizationKey: "klasor-modulu",
    },
    // {
    //   id: 6,
    //   baslikAdi: "Deneme Tahtası",
    //   route: ProgramPaths.eicrapro + "/deneme-tahtasi",
    //   icon: "mdi-test-tube",
    //   altbaslik: false,
    //   altbasliklar: null,
    //   authorizationKey: "klasor-modulu",
    // },
  ];

  davaProItems: Array<any> = [];

  arabulucuProItems: Array<any> = [];

  handleItemClick(event?: any, item?: any) {
    if (item && item.externalUrl) {
      if (event) event.preventDefault();
      // Dis link router'i atladigi icin rota kapisina hic ugramiyor;
      // yetki + lisans kontrolu burada tekrar edilmezse suresi dolmus
      // kullanici yeni sekmede urunu acabiliyordu.
      if (this.kalemPasif(item.authorizationKey)) return;
      window.open(item.externalUrl, "_blank", "noopener");
    }

    // Mobilde drawer'ı kapatmak için parent'a event emit et
    if (this.$vuetify.breakpoint.smAndDown) {
      this.$emit('close-drawer');
    }
  }

  /** Suresi bitmis urunde menu GORUNUR ama tiklanamaz. */
  menuKilitli = false;

  /** Yol -> (urun, kalemler) eslemesi. Tek yerde durur ki dallar ayrismasin. */
  private get urunMenuleri(): Array<{yol: string; urun: Product; kalemler: any[]}> {
    return [
      {yol: ProgramPaths.ofispro, urun: Product.OFISPRO, kalemler: this.ofisProItems},
      {yol: ProgramPaths.icrapro, urun: Product.ICRAPROWEB, kalemler: this.icraProItems},
      {yol: ProgramPaths.eicrapro, urun: Product.EICRAPRO, kalemler: this.eicraProItems},
      {yol: ProgramPaths.davapro, urun: Product.DAVAPROWEB, kalemler: this.davaProItems},
      {yol: ProgramPaths.arabulucupro, urun: Product.ARABULUCUPRO, kalemler: this.arabulucuProItems},
    ];
  }

  /**
   * DEV-2113 — menu ARTIK lisans yuzunden BOSALMIYOR.
   *
   * Onceden licenceIsValid() false ise items = [] yapiliyordu; yani suresi
   * dolmus kullanici sayfaya girse bile SOL MENUYU HIC GOREMIYORDU. Kisitli
   * donemin butun amaci "var olan dosyayla calismaya devam et" oldugu icin
   * bu davranis isi anlamsiz kiliyordu -- kullanici modullerin var oldugunu
   * bile bilmiyordu (09.09.2026 kullanici bildirimi).
   *
   * Yeni kural:
   *   gecerli / kisitli -> menu dolu ve TIKLANABILIR
   *   sure_bitti        -> menu dolu ama PASIF (sebep ipucunda; lisans ekranina
   *                        yonlendirme zaten router'da)
   *   yok               -> menu bos (urun hic satin alinmamis; gostermek anlamsiz)
   */
  /**
   * Menu YALNIZ rota degisiminde hesaplaniyordu; lisans listesi MenuBar
   * kuruldiktan SONRA dolarsa (ilk giris, /ben tazelemesi, urun degisimi)
   * menu bayat kaliyor ve kilit durumu gercegi yansitmiyordu. Lisanslar da
   * izleniyor -- ikisi de ayni hesabi tetikliyor.
   */
  @Watch("$store.getters.licenses", { deep: true })
  onLisansChange() {
    this.onUrlChange();
  }

  /** Özet tazelenince (özellik açıldı ya da kapandı) menü yeniden hesaplanır. */
  @Watch("$store.getters.ozellikDurumu", { deep: true })
  onOzellikDurumuChange() {
    this.onUrlChange();
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange() {
    // Lisans ekranindayken hangi urunun menusunu gosterecegimizi router
    // query ile tasiyor; boylece kullanici oradayken de modulleri GORUR
    // (pasif halde). Query yoksa normal yol coozumlemesi.
    const urunPath = "/" + sayfaUrunParcasi(this.$route.path, this.$route.query?.urun);
    const eslesme = this.urunMenuleri.find((m) => m.yol === urunPath);

    if (!eslesme || this.$helper.lisansDurumu(eslesme.urun) === "yok") {
      this.items = [];
      this.menuKilitli = false;
      return;
    }

    this.items = this.ozellikleSuz(eslesme.kalemler);
    this.menuKilitli = !this.$helper.lisansEkranlariAcikMi(eslesme.urun);
  }

  /**
   * DEV-2113 — 'ozellik' alanı taşıyan kalem yeni bir özelliğin sayfasıdır. Özellik bu
   * büroda kapalıysa kalem HİÇ görünmez (lisans kalemleri gibi pasif değil: büroda
   * böyle bir özellik yok). Adrese doğrudan gidilirse router "Bu özellik büronuzda
   * aktif değil" sayfasını açar. Bütün alt kalemleri kapalı olan grup da görünmez.
   */
  ozellikleSuz(kalemler: any[]): any[] {
    const acik = (kalem: any) => !kalem.ozellik || this.$helper.ozellikAcikMi(kalem.ozellik);
    return kalemler.filter(acik).flatMap((kalem: any) => {
      if (kalem.altbaslik !== true || !Array.isArray(kalem.altbasliklar)) return [kalem];
      const altbasliklar = kalem.altbasliklar.filter(acik);
      if (altbasliklar.length === kalem.altbasliklar.length) return [kalem];
      return altbasliklar.length > 0 ? [{...kalem, altbasliklar}] : [];
    });
  }

  /** Kalem pasif mi? Yetki VEYA lisans. */
  kalemPasif(izinAnahtari: string): boolean {
    return !this.$helper.isAuthorized(izinAnahtari) || this.menuKilitli || this.kalemLisansKisitli(izinAnahtari);
  }

  /** Kalem, bu buroda lisans yuzunden kapali bir islemi mi aciyor? */
  kalemLisansKisitli(izinAnahtari: string): boolean {
    const islem = MenuBar.LISANS_ISLEMI[izinAnahtari];
    return !!islem && this.$helper.lisansIslemKisitli(islem);
  }

  /** Ipucu metni: yetki sebebi ONCE gelir, sonra lisans. */
  kalemIpucu(izinAnahtari: string): string {
    if (!this.$helper.isAuthorized(izinAnahtari)) return "Bu işlem için yetkiniz yok.";
    if (this.menuKilitli) return "Kısıtlı mod sona erdi; bu bölüme girmek için süre uzatmanız gerekiyor.";
    if (this.kalemLisansKisitli(izinAnahtari)) return this.$helper.lisansIslemSebebi(MenuBar.LISANS_ISLEMI[izinAnahtari]);
    return "";
  }

  openDestekAI() {
    this.handleItemClick();
    openChatwoot().catch((err) => console.error(err));
  }

  // "İcraPro Web Kullanım Rehberi" yalnızca İcraPro menüsünde gösterilir.
  get isIcraPro(): boolean {
    return "/" + this.$route.path.split("/")[1] === ProgramPaths.icrapro;
  }

  openKullanimRehberi() {
    window.open(
      `https://www.youtube.com/watch?v=${RehberVideolari.genelKullanim}`,
      "_blank"
    );
  }
}
